import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule

import { ReactiveFormsModule } from '@angular/forms';

import { BlockTextComponent } from '../../../common/block-text/block-text.component';
import {
  InspirationInitModel,
  InspirationInitVariables,
  InspirationModel,
  InspirationVariables,
} from '../../../../../models/email-template/inspiration.interface';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { BaseComponent } from '../../../common/BaseComponent';
import { PinComponent } from '../../../common/pin/pin.component';
import { Helper } from '../../../../../utils/helper';

@Component({
    selector: 'app-inspiration',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './inspiration.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './inspiration.component.scss'
})
export class InspirationComponent extends BaseComponent implements OnInit {
  @Input() block: InspirationModel = new InspirationInitModel();
  @Input() isPreview = false;
  @Output() blockData = new EventEmitter<any>();
  @Output() removeBlockEvent = new EventEmitter<string | null>();

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new InspirationInitVariables()
    }
  }

  //placeholders:
  image1Placeholder: string = 'First Image';
  image2Placeholder: string = 'Second Image';
  image1HrefPlaceholder: string = 'Enter First Image Redirect Link';
  image2HrefPlaceholder: string = 'Enter Second Image Redirect Link';
  image1AltPlaceholder: string = 'Enter First Image Alt Text';
  image2AltPlaceholder: string = 'Enter Second Image Alt Text';
  heading1Placeholder: string = 'Enter First Heading';
  heading2Placeholder: string = 'Enter Second Heading';
  ctaLink1Placeholder: string = 'Enter First CTA Link';
  ctaText1Placeholder: string = 'Enter First CTA Text';
  ctaLink2Placeholder: string = 'Enter Second CTA Link';
  ctaText2Placeholder: string = 'Enter Second CTA Text';

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId); // Emit the ID to parent
  }

  onChange(value: any, fieldName: keyof InspirationVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }

  handleOnSegmentChange(segment: string, blockName: string) {
    if (this.block.variables) {
      this.block.variables[blockName as keyof InspirationVariables] = segment;
      this.blockData.emit(this.block);
    }
    return;
  }
}
